// Core JS controllers — barrel export
// Each theme imports this and registers all controllers via Stimulus.
// Controllers are NOT tree-shaken (bundler config disables treeshaking) so
// every controller is available at runtime for dynamic blocks/AJAX.

export { default as totop_controller } from './totop_controller.js';
export { default as flash_controller } from './flash_controller.js';
export { default as menu_button_controller } from './menu_button_controller.js';
export { default as mobile_menu_controller } from './mobile_menu_controller.js';
export { default as load_more_controller } from './load_more_controller.js';
export { default as searchbox_controller } from './searchbox_controller.js';
